import _taggedTemplateLiteral from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/UDFGE-ESHOP4-JOB1/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
import { jsx, jsxs } from 'react/jsx-runtime';
import { Column, Grid, Row } from '@dls/web';
import styled from 'styled-components';
import List from '../EmpowerHeader/List.js';
import ListItem from '../EmpowerHeader/ListItem.js';
import Logo from '../EmpowerHeader/Logo.js';
import { SCHeaderDesktop } from '../EmpowerHeader/styles.js';
import PublicDesktopMenu from './DesktopPublicMenu/index.js';
const SCFlexColumnAuto = styled(Column)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  flex: 1 0 auto;\n  padding: 0;\n"])));
const SCFlexColumnAutoEnd = styled(Column)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  flex: 0 0 auto;\n"])));
const LogoListItem = styled(ListItem)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  /* margin-right: 10px; */\n"])));
const SCDivW100 = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
const HeaderGrid = styled(Grid)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  padding: 6px;\n"])));
const DesktopControls = _ref => {
  let {
    additionalControl
  } = _ref;
  return /* @__PURE__ */jsx(List, {
    isInline: true,
    children: additionalControl
  });
};
const PublicDesktopHeader = _ref2 => {
  let {
    baseUrl,
    logoLink,
    logoAlt,
    logoSrc,
    menuHoverKey,
    onMenuMouseEnter,
    onMenuMouseLeave,
    theme,
    menuItems = [],
    additionalControl
  } = _ref2;
  return /* @__PURE__ */jsx(SCDivW100, {
    children: /* @__PURE__ */jsx(SCHeaderDesktop, {
      theme,
      id: "deskMenuBottom",
      children: /* @__PURE__ */jsx(HeaderGrid, {
        children: /* @__PURE__ */jsxs(Row, {
          middle: "sm",
          children: [/* @__PURE__ */jsx(SCFlexColumnAuto, {
            children: /* @__PURE__ */jsxs(List, {
              isInline: true,
              children: [/* @__PURE__ */jsx(LogoListItem, {
                children: /* @__PURE__ */jsx(Logo, {
                  baseUrl,
                  link: logoLink,
                  alt: logoAlt,
                  src: logoSrc,
                  showAlt: false
                })
              }), /* @__PURE__ */jsx(PublicDesktopMenu, {
                baseUrl,
                menuItems,
                menuHoverKey,
                onMenuMouseEnter,
                onMenuMouseLeave,
                theme
              })]
            })
          }), /* @__PURE__ */jsx(SCFlexColumnAutoEnd, {
            children: /* @__PURE__ */jsx(DesktopControls, {
              theme,
              additionalControl
            })
          })]
        })
      })
    })
  });
};
export { PublicDesktopHeader as default };